import {FetchGuideParams} from '@blesk-frontend/api';
import {createFileRoute} from '@tanstack/react-router';
import {GuidesListPage} from '@/features/guides';

interface GuidesListSearchSchema {
  search: {
    search?: string;
    owned?: boolean;
    favorites?: boolean;
    trash?: boolean;
    redirect?: string;
    sort?: 'createdAt' | 'updatedAt' | 'name';
    page?: number;
    extensionOnboard?: boolean;
    limit?: boolean;
  };
}

export const Route = createFileRoute('/_app/')({
  validateSearch: (search: GuidesListSearchSchema['search']) => {
    return search;
  },
  beforeLoad: ({search}) => ({
    getTitle: () => {
      if (search.search) {
        return `${search.search}`;
      }
      if (search.favorites) {
        return 'Избранное';
      }
      if (search.trash) {
        return 'Корзина';
      }
      return 'Инструкции';
    },
  }),
  loaderDeps: ({search}: GuidesListSearchSchema): {params: FetchGuideParams} => {
    const localStorageSort = localStorage.getItem('guides-list-sort') as
      | 'createdAt'
      | 'updatedAt'
      | 'name'
      | undefined;

    return {
      params: {
        filter: {
          ...(search.search && {search: search.search}),
          ...(search.owned && {owned: search.owned}),
          ...(search.favorites && {favorites: search.favorites}),
          ...(search.trash && {trash: search.trash}),
        },
        sort: search.sort || localStorageSort || 'updatedAt',
        page: search.page,
      },
    };
  },
  component: () => <GuidesListPage />,
});
